var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import _ from 'lodash';
import PersistentCollection from '../PersistentCollection';
import AssetModel from '../../models/AssetModel';
import ViewOptions from '../../views/pages/Assets/data/ViewOptions';
import FilterRuleContainsString from '../filters/FilterRuleContainsString';
import FilterObjectRule from '../filters/FilterObjectRule';
import ClusterProperties from '../../views/pages/Assets/data/ClusterProperties';
import FilterRuleArrayContains from '../filters/FilterRuleArrayContains';
import { toCSV, toXLSX } from '../../utils/exportUtils';
import { compareDates, compareNumbers, compareStrings } from '../../utils/compareUtils';
import * as atlas from "azure-maps-control";
var BoundingBox = atlas.data.BoundingBox;
var Position = atlas.data.Position;
/**
 *
 */
var AssetCollection = /** @class */ (function (_super) {
    __extends(AssetCollection, _super);
    /**
     *
     */
    function AssetCollection(isPersistent, storageName) {
        if (isPersistent === void 0) { isPersistent = true; }
        if (storageName === void 0) { storageName = 'AssetCollection'; }
        var _this = _super.call(this, AssetModel, isPersistent, storageName) || this;
        _this.viewOption = ViewOptions.ACTIVITY;
        _this.clusterType = ClusterProperties.ACTIVITY;
        _this.locationStatusFilter = new FilterObjectRule(['properties', 'locationStatus']);
        _this.activityStatusFilter = new FilterObjectRule(['activityStatus']);
        _this.labelsFilter = new FilterRuleArrayContains(['labelFilterArray'], false);
        _this.searchStringFilter = new FilterRuleContainsString('_filterString');
        _this.searchStringFilter.includeInFilterCount = false;
        _this.searchStringFilter.includeInReset = false;
        _this.filter.addRule(_this.searchStringFilter);
        _this.filter.addRule(_this.locationStatusFilter);
        _this.filter.addRule(_this.activityStatusFilter);
        _this.filter.addRule(_this.labelsFilter);
        // naming for hash
        _this.activityStatusFilter.name = 'activity';
        _this.labelsFilter.name = 'labels';
        return _this;
    }
    Object.defineProperty(AssetCollection.prototype, "boundingBox", {
        /**
         *
         * @return {atlas.data.BoundingBox}
         */
        get: function () {
            var assets = this.list;
            var positions = assets.map(function (assetModel) {
                if (assetModel.geometry.coordinates[0] === 0 && assetModel.geometry.coordinates[1] === 0) {
                    return null;
                }
                return new Position(assetModel.geometry.coordinates[0], assetModel.geometry.coordinates[1]);
            }).filter(function (val) { return val != null; });
            return BoundingBox.fromPositions(positions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetCollection.prototype, "filteredBoundingBox", {
        /**
         *
         * @return {atlas.data.BoundingBox}
         */
        get: function () {
            var positions = this.filtered.map(function (assetModel) {
                if (assetModel.geometry.coordinates[0] === 0 && assetModel.geometry.coordinates[1] === 0) {
                    return null;
                }
                return new Position(assetModel.geometry.coordinates[0], assetModel.geometry.coordinates[1]);
            }).filter(function (val) { return val != null; });
            return BoundingBox.fromPositions(positions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetCollection.prototype, "averageCoordinates", {
        /**
         *
         */
        get: function () {
            var assets = this.filtered;
            var x = 0, y = 0;
            var minX = Number.MAX_VALUE, minY = Number.MAX_VALUE;
            var maxX = 0, maxY = 0;
            assets.forEach(function (assetModel) {
                var coord = assetModel.geometry.coordinates;
                minX = minX > coord[0] ? coord[0] : minX;
                minY = minY > coord[1] ? coord[1] : minY;
                maxX = maxX < coord[0] ? coord[0] : maxX;
                maxY = maxY > coord[1] ? coord[1] : maxY;
                x += coord[0];
                y += coord[1];
            });
            var avgX = x / assets.length;
            var avgY = y / assets.length;
            avgX = isNaN(avgX) ? 0 : avgX;
            avgY = isNaN(avgY) ? 0 : avgY;
            return [avgX, avgY];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetCollection.prototype, "uniqueLabels", {
        /**
         *
         * @return {Array}
         */
        get: function () {
            var labels = [];
            this.list.forEach(function (asset) {
                labels = labels.concat(asset.labels);
            });
            return _.uniqWith(labels, function (labelA, labelB) { return labelA.id === labelB.id; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param array
     */
    AssetCollection.prototype.addAll = function (array) {
        if (array) {
            _super.prototype.addAll.call(this, array);
            this.firstFetchComplete = true;
        }
    };
    /**
     *
     */
    AssetCollection.prototype.reset = function (resetFilters) {
        if (resetFilters === void 0) { resetFilters = true; }
        _super.prototype.reset.call(this, resetFilters);
    };
    /**
     *
     */
    AssetCollection.prototype.resetAll = function () {
        this.reset(true);
        this.fetching = null;
        this.firstFetchComplete = false;
        this.viewOption = ViewOptions.ACTIVITY;
        this.clusterType = ClusterProperties.ACTIVITY;
    };
    /**
     *
     * @param type
     * @param intl
     */
    AssetCollection.prototype.export = function (type, intl) {
        // Headers
        var rows = [[
                intl.formatMessage({ id: 'page.assets.table.column.id' }),
                intl.formatMessage({ id: 'page.assets.table.column.make' }),
                intl.formatMessage({ id: 'page.assets.table.column.model' }),
                intl.formatMessage({ id: 'page.assets.table.column.serialnumber' }),
                intl.formatMessage({ id: 'page.assets.table.column.labels' }),
                intl.formatMessage({ id: 'page.assets.table.column.operatinghours' }),
                intl.formatMessage({ id: 'page.assets.table.column.operatinghours' }) + ' datum',
                intl.formatMessage({ id: 'page.assets.table.column.fuelusage' }),
                intl.formatMessage({ id: 'page.assets.table.column.fuelusage' }) + ' datum',
                intl.formatMessage({ id: 'page.assets.table.column.location' }),
                intl.formatMessage({ id: 'page.assets.table.column.location' }) + ' datum',
            ]];
        // Content
        rows = rows.concat(this.filteredAndSorted.map(function (assetModel) {
            return [
                assetModel.properties.equipmentId,
                assetModel.properties.make,
                assetModel.properties.model,
                assetModel.properties.serialNumber,
                assetModel.labels.map(function (labelModel) {
                    return labelModel.name;
                }).join(', '),
                assetModel.properties.cumulativeOperatingHoursDurationInHours,
                assetModel.cumulativeOperatingHoursDateTime,
                assetModel.properties.fuelUsedInLiters,
                assetModel.fuelUsedDateTime,
                assetModel.place,
                assetModel.locationDateTime,
            ];
        }));
        var fileName = intl.formatDate(new Date(), { year: 'numeric', month: 'numeric', day: 'numeric' }) + ' ' + intl.formatTime(new Date()) + '_assets';
        switch (type) {
            case 'xlsx':
                toXLSX(rows, fileName);
                break;
            case 'csv':
                toCSV(rows, fileName);
        }
    };
    /**
     *
     * @param items
     * @return {*}
     * @private
     */
    AssetCollection.prototype.applySort = function (items) {
        var sort = this.sort;
        if (!sort)
            return items;
        var result = items.concat([]);
        result.sort(function (a, b) {
            switch (sort.fieldName) {
                case 'id':
                    return compareStrings(a.id, b.id);
                case 'make':
                    return compareStrings(a.properties.make, b.properties.make);
                case 'model':
                    return compareStrings(a.properties.model, b.properties.model);
                case 'batteryStatus':
                    return compareNumbers(a.batteryRemainingPct, b.batteryRemainingPct);
                case 'activityStatus':
                    return compareStrings(a.activityStatus, b.activityStatus);
                case 'serialNumber':
                    return compareStrings(a.properties.serialNumber, b.properties.serialNumber);
                case 'cumulativeOperatingHoursDurationInHours':
                    return compareNumbers(a.cumulativeOperatingHoursDurationInHours, b.cumulativeOperatingHoursDurationInHours);
                case 'fuelUsedInLiters':
                    return compareNumbers(a.fuelUsedInLiters, b.fuelUsedInLiters);
                case 'labels':
                    if (a.labels.length === b.labels.length) {
                        return compareStrings(a.labelSortString, b.labelSortString);
                    }
                    else {
                        return compareNumbers(a.labels.length, b.labels.length);
                    }
                case 'serviceEntries':
                    return compareNumbers(a.serviceEntries.length, b.serviceEntries.length);
                case 'lastModifiedTimestamp':
                    return compareDates(a.lastModifiedTimestamp, b.lastModifiedTimestamp);
                case 'locationDateTime':
                    return compareDates(a.locationDateTime, b.locationDateTime);
                case 'place':
                    return compareStrings(a.place, b.place);
            }
        });
        if (sort.direction < 0) {
            result.reverse();
        }
        return result;
    };
    __decorate([
        observable
    ], AssetCollection.prototype, "fetching", void 0);
    __decorate([
        observable
    ], AssetCollection.prototype, "viewOption", void 0);
    __decorate([
        observable
    ], AssetCollection.prototype, "clusterType", void 0);
    return AssetCollection;
}(PersistentCollection));
export default AssetCollection;
